import React from 'react';
import { RouterConfig } from '../../config/router';
import { UnderOverMenu } from '../../components/UnderOverMenu';

const allPageTile = [
  {
    title: '0.5',
    over: RouterConfig.CardOverZero,
    under: RouterConfig.CardUnderZero,
  },
  {
    title: '1.5',
    over: RouterConfig.CardOverOne,
    under: RouterConfig.CardUnderOne,
  },
  {
    title: '2.5',
    over: RouterConfig.CardOverTwo,
    under: RouterConfig.CardUnderTwo,
  },
  {
    title: '3.5',
    over: RouterConfig.CardOverThree,
    under: RouterConfig.CardUnderThree,
  },
  {
    title: '4.5',
    over: RouterConfig.CardOverFour,
    under: RouterConfig.CardUnderFour,
  },
  {
    title: '5.5',
    over: RouterConfig.CardOverFive,
    under: RouterConfig.CardUnderFive,
  },
  {
    title: '6.5',
    over: RouterConfig.CardOverSix,
    under: RouterConfig.CardUnderSix,
  },
];

export default function UnderOverYellowCards() {
  return <UnderOverMenu menu={allPageTile} title="Wybór żółtych kartek" />;
}
